module.exports = __webpack_public_path__ + "static/Reggie-Headshot-4c7829a54c3e31cf82e536faf1c4eb3a.jpg";